<template>
    <CSelect
        :isValid="isValid"
        :value.sync="language"
        :options="languages"
        @change="$emit('update:value',parseInt($event.target.value))"

        :label="label"
        :placeholder="placeholder"
        :invalidFeedback="invalidFeedback"
        :horizontal="horizontal"
        :size="size"
        :disabled="disabled" 
    />
</template>

<script>
import { mapGetters } from "vuex";
import axios from 'axios';
export default {
    name: "SelectLanguage",

    props: {
        isValid: {
            type: Boolean,
            default: null
        },
        label: {
            type:String,
            default: null
        },
        value:{
            default: null
        },
        horizontal:{
            default: false
        },
        placeholder:{
            default:null
        },
        invalidFeedback:{
            default:undefined
        },
        size:{
            default:undefined
        },
        disabled:{
            default:false
        } 
    },
    data(){
        return{
            languages:[],
            language:null
        }
    },
    computed:{
        ...mapGetters({
            storeGlobalLanguages: "global/languages",
        })
    },
    watch:{
        value(newValue){
            this.language = parseInt(newValue);
        }
    },
    methods:{
        getLanguages:async function() {
            try {
                let data = [];
                if(this.storeGlobalLanguages.length > 0){
                    data = this.storeGlobalLanguages;
                }else{
                    let response = await axios.get('/language');
                    data = response.data;
                    this.$store.dispatch("global/saveLanguages",{ languages: data });    
                }

                if(data.length > 0){
                    this.languages = data.map(language => {
                        return {
                            value: language.id,
                            label: language.name
                        }
                    });
                }
            } catch (error) {
                console.log(error);
            }
        },
    },
    async mounted(){
        await this.getLanguages();
        this.language = parseInt(this.value);
    }   

}
</script>
<style>

</style>